import { styled } from "@mui/material/styles";

export const RegularGridLegend = styled("div")`
  width: 20px;
  height: 20px;
  border: 2px solid #3388ff;
  background-color: #d5e6fe;
`;
